// LOGO POR TENANT: quem manda no tamanho da logo é o campo `tamanho_logo` do CRM
// (Personalizar site › Logo, Favicon & Vídeo) — mas SÓ para os codsites listados aqui.
//
// Por que allowlist: cada lugar onde a logo aparece (topo, menu lateral, rodapé) tem um
// tamanho fixo próprio há anos, e 127 tenants ativos têm `tamanho_logo` acima do teto do
// topo (alguns com 800, 3600, 40000) sem nunca terem visto efeito. Liberar geral mudaria
// a cara de todos eles de uma vez.
export const LOGO_SEGUE_TAMANHO_CRM = new Set([2600]);

// Régua da escala: o teto histórico da logo do topo. `tamanho_logo` = 171 significa
// "tamanho de sempre"; 210 significa ~23% maior em todo lugar.
const TETO_LOGO_TOPO = 171;

// Trava de segurança: um valor extremo digitado no CRM não pode deformar o site.
// (Cada lugar ainda tem o teto próprio dele — ex.: a logo do topo no celular.)
const ESCALA_MAX = 2;

/**
 * Fator a aplicar sobre o tamanho base da logo de cada lugar (topo no celular, menu
 * lateral, rodapé). Retorna `null` para tenant fora da allowlist — aí tudo segue o
 * tamanho fixo de sempre.
 */
export function escalaLogoCrm(site: any): number | null {
  if (!LOGO_SEGUE_TAMANHO_CRM.has(Number(site?.id))) return null;

  const tamanhoCrm = Number(site?.tamanho_logo);
  if (!Number.isFinite(tamanhoCrm) || tamanhoCrm <= 1) return null;

  return Math.min(tamanhoCrm / TETO_LOGO_TOPO, ESCALA_MAX);
}
